<!--建筑能耗首页右边-->
<template>
	<div class="homeRigthBody">
		<div class="overview_top">
			<div class="homeRigthBodyTop">
				<el-radio-group v-model="radioValue">
					<el-radio-button label="日"></el-radio-button>
					<el-radio-button label="月"></el-radio-button>
					<el-radio-button label="季"></el-radio-button>
					<el-radio-button label="年"></el-radio-button>
				</el-radio-group>
			</div>
			<!--水电气集合-->
			<div class="hydropowerDiv">
				<div class="leftImgRigthSpan">
					<img :src="getImage('yt1.png')" />
					<div class="rigthSpan">
						<p>{{radioValue}}用电量</p>
						<p>{{waterAndElectricity.electricityCount}}kWh</p>
					</div>
				</div>
				<div class="leftImgRigthSpan">
					<img :src="getImage('yt2.png')"/>
					<div class="rigthSpan">
						<p>{{radioValue}}用水量</p>
						<p>{{waterAndElectricity.waterCount}} m³</p>
					</div>
				</div>
				<div class="leftImgRigthSpan">
					<img :src="getImage('yt3.png')" />
					<div class="rigthSpan">
						<p>{{radioValue}}用气量</p>
						<p>{{waterAndElectricity.gasCount}} m³</p>
					</div>
				</div>
				<div class="leftImgRigthSpan">
					<img :src="getImage('yt4.png')" />
					<div class="rigthSpan">
						<p>本{{radioValue}}折标煤</p>
						<p>{{getStandardCoal}} kgce</p>
					</div>
				</div>
				<div class="leftImgRigthSpan">
					<img :src="getImage('yt5.png')" />
					<div class="rigthSpan">
						<p>本{{radioValue}}碳排量</p>
						<p>{{getCarbonEmissions}} kg</p>
					</div>
				</div>
			</div>
		</div>
		<!--看板分析-->
		<div class="KanbanAnalysisBody">
			<analysisModule v-if='childData' titleColor="#00a843" unit="KWh" :dataList="electricityData" :xData="electricityXdata" type="电"></analysisModule>
			<analysisModule v-if='childData' titleColor="#00bfef" unit="m³" :dataList="wateData" :xData="waterXdata" type="水"></analysisModule>
			<analysisModule v-if='childData' titleColor="#9b63b9" unit="Nm³" :dataList="gasData" :xData="gasXdata" type="气"></analysisModule>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import analysisModule from './analysisModule.vue'
	export default {
		components: {
			analysisModule,
		},
		props: {
			areausePower: {}, //分项信息
		},
		data() {
			return {
				radioValue: "日",
				electricityXdata: [],
				waterXdata: [],
				gasXdata: [],
				electricityData: [], //电数据
				wateData: [], //水数据
				gasData: [], //气数据
				childData: false,
				waterAndElectricity: {
					electricityCount: 0,
					gasCount: 0,
					waterCount: 0,
				}
			}
		},
		created() {},
		mounted() {
			this.initData()
			this.getData()
		},
		destroyed() {},
		computed: {
			getImage() {
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/overview/' + img)
				}
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getStandardCoal() {
				let electricityCount = Number(this.waterAndElectricity.electricityCount) * 0.1229
				let waterCount = Number(this.waterAndElectricity.gasCount) * 1.2143
				return(electricityCount + waterCount).toFixed(2)
			},
			getCarbonEmissions() {
				return(this.getStandardCoal * 2.493).toFixed(2)
			}

		},
		watch: {
			areausePower(nv, ov) {
				this.initData()
			},
			radioValue(nv, ov) {
				this.getData()
			}
		},
		methods: {
			initData() {
				if(!isempty(this.areausePower)) {
					this.electricityXdata = []
					this.waterXdata = []
					this.gasXdata = []
					let eleVariableList = '' //电变量
					let waterVariableList = '' //水变量
					let gasVariableList = '' //气变量
					let bgTime = new Date().getTime()
					let endTime = new Date().getTime()
					let obj = {}
					let data = [5, 2, 3, 4, 5, 9, 8]
					this.areausePower.electricity.forEach(item => {
						this.electricityXdata.push(item.areaname.split('_')[1])
						eleVariableList += item.relatVariabel + ','
						obj[item.areaname.split('_')[1]] = data
					})
					this.electricityData = obj
					obj = {}
					this.areausePower.water.forEach(item => {
						this.waterXdata.push(item.areaname.split('_')[1])
						waterVariableList += item.relatVariabel + ','
						obj[item.areaname.split('_')[1]] = data
					})
					this.wateData = obj
					obj = {}
					this.areausePower.gas.forEach(item => {
						this.gasXdata.push(item.areaname.split('_')[1])
						waterVariableList += item.relatVariabel + ','
						obj[item.areaname.split('_')[1]] = data
					})
					this.gasData = obj
					this.childData = true
				}
			},
			getData() {
				this.$api.areausePower.getWaterAndElectricity(this.nowUnit.id, this.radioValue, respon => {
					this.$store.cacheStore.state.load = false
					this.waterAndElectricity = respon
				})
			}
		}
	}
</script>

<style scoped>
	.homeRigthBody {
		width: calc(80% - .22rem);
		height: 95%;
		margin-left: .1rem;
		margin-right: .1rem;
	}
	.overview_top{
		width: 100%;
		height: 20%;
		border: .01rem solid #2e43b0;
		background-color: #010e5e;
		margin-bottom: .1rem;
		border-radius: .1rem;
	}
	.homeRigthBodyTop {
		width: 100%;
		height: 20%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.hydropowerDiv {
		width: 100%;
		height: 80%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.leftImgRigthSpan {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.leftImgRigthSpan img {
		padding-right: .1rem;
	}
	
	.rigthSpan p {
		font-size: .2rem;
		line-height: .3rem;
	}
	
	.rigthSpan p:nth-child(2) {
		font-size: .3rem;
	}
	
	.KanbanAnalysisBody {
		width: 100%;
		height: calc(80% - .1rem);
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
	}
</style>
<style>
	.homeRigthBodyTop .el-radio-group {
		margin-left: .2rem;
		background-color: #11173c;
	}
	
	.homeRigthBodyTop .el-radio-button__inner {
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	
	.homeRigthBodyTop .el-radio-button:first-child .el-radio-button__inner {
		border-left: 1px solid #0775a5;
	}
</style>